import { getUniqueAndSortedSizes } from './helpers';
import type { Img } from './types';

/**
 * получить массив изображений из sizesImages, у которых ширина
 * равна или больше значений из sizesUsed
 * @param sizesUsed
 * @param sizesImages
 * @returns
 */
// * Подбирает подходящие изображения для заданных размеров:
// * 1. Сортирует запрошенные размеры
// * 2. Для каждого запрошенного размера находит ближайшее большее или равное изображение
// * 3. Если подходящих изображений нет, возвращает самое большое доступное
export function getImagesBySizes(sizesUsed: number[], sizesImages: Img[]): Img[] {
  const sortSizesUsed = sizesUsed.sort((a, b) => a - b);
  const uniqueAndSortedSizes = getUniqueAndSortedSizes(sizesImages);

  const res = sortSizesUsed.reduce((result: Record<number, Img>, sizeUsed: number) => {
    const sizeImageBysizeUsed = uniqueAndSortedSizes.find(
      (sizeImage: Img) => sizeImage.width >= sizeUsed,
    );

    if (sizeImageBysizeUsed) {
      return {
        ...result,
        [sizeUsed]: sizeImageBysizeUsed,
      };
    }
    return result;
  }, {});

  return Object.values(res).length
    ? getUniqueAndSortedSizes(Object.values(res))
    : uniqueAndSortedSizes.slice(-1);
}
